import Vue from 'vue';
import FormScribbleElement from './FormScribbleElement';

export default Vue.extend({
  name: 'FormSignatureElement',
  functional: true,
  render: function (h, context) {
    return h(FormScribbleElement, context.data, context.children);
  }
});
